export default __webpack_public_path__ + "static/media/Overrated_small.e4ce7d66.svg";